<template>
  <div class="flex flex-col items-center content-center justify-center p-5">
    <div class="w-full max-w-3xl">
      <ExternalTaskUpdated />
    </div>
  </div>
</template>

<script>
import ExternalTaskUpdated from '@/components/ExternalTaskUpdated'

export default {
  name: 'ExternalTaskUpdatedView',

  components: {
    ExternalTaskUpdated
  }
}
</script>
